import { Model, Attr } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'

@Model()
export default class Notification extends ApplicationRecord {
  static jsonapiType = 'notifications'

  @Attr() kind!: string
  @Attr() startDate!: Date
  @Attr() endDate!: Date
  @Attr() homeBanner!: boolean
  @Attr() title!: string
  @Attr() description!: string
  @Attr() content!: string
  @Attr() createdAt!: Date
  @Attr() bannerImage!: string
}
